import { useEffect, useState } from "react";
import { useSocket } from "components";
import { ISocketService, useTaggerActions } from "store";
import { GPTResults } from "../../store/types/tagger/api";

const eventName = "textract.result";
const channelName = "private-textract-result";

const nlpEventName = "nlp.result";
const nlpChannelName = "private-nlp-result";

export function useTextractSocketHook() {
  const { updatePolygons, getDocumentPolygons, fetchTags, setAnalyzingStatus } = useTaggerActions();
  const [subscribed, setSubscribed] = useState(false);

  const socket: ISocketService = useSocket();

  // Subscribe
  useEffect(() => {
    const channel = socket.subscribe(channelName);
    console.log("[Subscribe to Textract]");

    channel.bind(
      eventName,
      ({ series, doc_id, documents }: { series: string; doc_id?: string; documents?: string[] }) => {
        const documentIds = documents || [doc_id as string];
        documentIds.forEach((doc) => {
          getDocumentPolygons(Number(doc)).then((polygons) => {
            updatePolygons({
              data: { series, doc, polygons },
              error: null,
              reqId: ""
            });
          });
        });
      }
    );

    setSubscribed(true);

    return () => {
      channel.unbind_all();
      socket.unsubscribe(channelName);
      console.log("[Unsubscribe from Textract]");
    };
  }, []);

  // Subscribe to NLP results
  useEffect(() => {
    const channel = socket.subscribe(nlpChannelName);
    console.log("[Subscribe to NLP]");

    channel.bind(nlpEventName, ({ doc }: { doc: string; suspects: GPTResults[] }) => {
      setAnalyzingStatus("finished");
      fetchTags({ docId: Number(doc), overrideStateTags: true });
    });

    return () => {
      channel.unbind_all();
      socket.unsubscribe(nlpChannelName);
      console.log("[Unsubscribe from Textract]");
    };
  }, []);

  return subscribed;
}
